import { Grid } from "@mui/material";
import { GridItem } from "Components/Shared/GridItem";
import { FormSection } from "Components/Shared/FormSection";
import type { PartyDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { getFormattedAddress } from "Utils/AddressUtils";

const ADDRESS_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.AddressFields;

type Props = {
  party: PartyDto;
};

export const AddressesSection = ({ party: { addresses } }: Props) => {
  const { t } = useResource();

  if (addresses.length === 0) {
    return null;
  }

  return (
    <>
      {addresses.map((address, index) => {
        const title =
          addresses.length > 1
            ? `${index + 1}. ${t(ADDRESS_RESOURCES.Legend)}`
            : t(ADDRESS_RESOURCES.Legend);

        return (
          <FormSection
            legend={title}
            key={address.addressID || index}
            noMargins
          >
            <Grid container spacing={2}>
              <GridItem
                columns={2}
                label={t(ADDRESS_RESOURCES.Type)}
                value={t(Resources.Form.AddressType[address.type])}
              />
              <GridItem
                columns={2}
                label={t(ADDRESS_RESOURCES.Legend)}
                value={getFormattedAddress(address)}
              />
            </Grid>
          </FormSection>
        );
      })}
    </>
  );
};
